// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import AngleDown from "@flip/XDL/Icons/AngleDown";
import { fontConfig } from "@flip/XDL/PreStyle/typography";
import { xBaseTheme } from "@flip/XDL/types";
import { color } from "@flip/XDL/Utilities";
import DynamicDropdownPresentationPropsDefault from "@insite/mobius/DynamicDropdown/presentationProps";
import { IconWrapper } from "@insite/mobius/Icon";
import { css } from "styled-components";

export default {
    defaultProps: {
        ...DynamicDropdownPresentationPropsDefault,

        cssOverrides: {
            option: css`
                font-size: 16px;
                font-weight: ${fontConfig.weight.regular};
                letter-spacing: 0;
                line-height: 26px;
                color: ${color("text.main")};
                padding: 10px;

                &:hover {
                    background: ${color("common.ui2")};
                }
            `,
            // XNG-Changes: FLIP-470
            dropdownWrapper: css`
                && input[aria-expanded="true"] ~ ${IconWrapper} svg {
                    transform: rotate(180deg);
                }
            `,
            list: css`
                box-shadow: none;
                border: 1px solid ${color("common.ui12")};
                width: 100%;
                margin-top: -4px;
                border-radius: 0 0 2px 2px;
            `,
            formInputWrapper: css`
                [role="combobox"][aria-expanded="true"] {
                    svg {
                        transform: rotate(180deg);
                    }
                }

                input:not(:disabled):hover {
                    border: 1px solid ${color("common.ui13")};
                }
            `,
        },
        iconProps: {
            src: AngleDown,
            size: 10,
            color: "common.ui5",
            css: css`
                &&& {
                    display: flex;
                    justify-content: flex-end;
                    padding-right: 10px;
                    width: auto;
                }
                svg {
                    width: 9px;
                    height: 12px;
                }
            `,
        },
    },
} as xBaseTheme["dynamicDropdown"];
